module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/approved-drawing/approved-drawing.component.css
// module id = ./src/app/planning/approved-drawing/approved-drawing.component.css
// module chunks = main